import React from 'react';
import ReviewLicenseFilter from './filters/ReviewLicenseFilter';

const DrawerReviewLicensePanel = () => <ReviewLicenseFilter />;

export default DrawerReviewLicensePanel;
